import React, {FC} from "react";
import {Checkbox, InputNumber, Select, Row, Col} from "antd";
import {FormikProps} from "formik";
import {EditCourseInput, NewCourseInput, useGetAppSettingsInvoiceDueDaysQuery} from "../../../generated/graphql";
import i18n from "../../../services/i18n";

const {Option} = Select;

type CustomInvoiceDueDaysInputProps = {
    formikProps: FormikProps<NewCourseInput | EditCourseInput>;
    style?: React.CSSProperties;
};

const CustomInvoiceDueDaysInput: FC<CustomInvoiceDueDaysInputProps> = ({formikProps, style}) => {
    const {data: settingsData} = useGetAppSettingsInvoiceDueDaysQuery();
    const orgDefault = settingsData?.settings?.invoiceDueDays ?? 7;

    const currentValue = formikProps.values.customInvoiceDueDays;
    const isEnabled = currentValue != null;
    const days = isEnabled ? Math.abs(currentValue) : orgDefault;
    const direction = isEnabled && currentValue < 0 ? "after" : "before";

    const handleToggle = (checked: boolean) => {
        if (checked) {
            formikProps.setFieldValue("customInvoiceDueDays", orgDefault);
        } else {
            formikProps.setFieldValue("customInvoiceDueDays", null);
        }
    };

    const handleDaysChange = (value: number | null) => {
        if (value == null || value < 0) return;
        const sign = direction === "after" ? -1 : 1;
        formikProps.setFieldValue("customInvoiceDueDays", value * sign);
    };

    const handleDirectionChange = (dir: string) => {
        const sign = dir === "after" ? -1 : 1;
        formikProps.setFieldValue("customInvoiceDueDays", days * sign);
    };

    return (
        <div style={style}>
            <Checkbox checked={isEnabled} onChange={(e) => handleToggle(e.target.checked)}>
                {i18n.containers.courses.CustomInvoiceDueDays.checkbox()}
            </Checkbox>
            {isEnabled && (
                <Row gutter={8} style={{marginTop: 8}}>
                    <Col>
                        <InputNumber
                            min={0}
                            max={365}
                            precision={0}
                            value={days}
                            onChange={(val) => handleDaysChange(val as number | null)}
                        />
                    </Col>
                    <Col>
                        <Select value={direction} onChange={handleDirectionChange} style={{width: 200}}>
                            <Option value="before">{i18n.containers.courses.CustomInvoiceDueDays.beforeCourseStart()}</Option>
                            <Option value="after">{i18n.containers.courses.CustomInvoiceDueDays.afterCourseStart()}</Option>
                        </Select>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default CustomInvoiceDueDaysInput;
